import * as actionTypes from './actionTypes'

const initialState = {
  user: false,
  category: false,
  series: false,
  parts: false, 
  images: false,
  taxes: false,
  coupons: false,
  goDown: false,
  locations: false,
  partners: false,
  partnerRequests:false,
  appUsers:false,

  showAddCategory: false,
  showAddSeries: false,
  showAddPart: false,
  showAddPartner: false,

  activeCategory: false,
  activeSeries: false,
  activePart: false,
  activePartner: false,
  activePartnerRequest:false,
  activeAppUser:false,

} 
const reducer =  (state = initialState, action) => {
  switch (action.type) { 
    case actionTypes.SET_ACTIVE_PARTNER:
      return {...state,activePartner: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_PARTNERS:
      return {...state,partners: action.payload}
    case actionTypes.SET_ADD_PARTNER:
      return {...state,showAddPartner: action.payload}
    
    case actionTypes.SET_ACTIVE_PARTNER_REQUEST:
      return {...state,activePartnerRequest: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_PARTNER_REQUESTS:
      return {...state,partnerRequests: action.payload}
    case actionTypes.SET_ACTIVE_APPUSER:
      return {...state,activeAppUser: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_APPUSERS:
      return {...state,appUsers: action.payload}

    case actionTypes.SET_ACTIVE_SERIES:
      return {...state,activeSeries: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_ACTIVE_PART:
      return {...state,activePart: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_ACTIVE_CATEGORY:
      return {...state,activeCategory: action.payload.status == "Active" ? action.payload : false}
    case actionTypes.SET_ADD_PART:
      return {...state,showAddPart: action.payload}
    case actionTypes.SET_ADD_SERIES:
      return {...state,showAddSeries: action.payload}
    case actionTypes.SET_ADD_CATEGORY:
      return {...state,showAddCategory: action.payload}
    case actionTypes.SET_LOCATION:
      return {...state,locations: action.payload}
    case actionTypes.SET_GODOWN:
      return {...state,goDown: action.payload}
    case actionTypes.SET_TAXES:
      return {...state,taxes: action.payload}
    case actionTypes.SET_COUPONS:
      return {...state,coupons: action.payload}
    case actionTypes.ADD_IMAGE:
      let imgs = state.images;
      if(imgs)
        imgs.unshift(action.payload) 
      else
        imgs = [action.payload]
  
      return {...state,images: [...imgs]}
    case actionTypes.SET_PARTS:
      return {...state,parts: action.payload}
    case actionTypes.SET_SERIES:
      return {...state,series: action.payload}
    case actionTypes.SET_CATEGORY:
      return {...state,category: action.payload}
    case actionTypes.SET_USER:
      return {...state,user: action.payload}
    default:
      return state
  }
}

export default reducer;